import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col } from '../../components/Col';
import NewAutoCompleteField from '../../components/NewAutoCompleteField/NewAutoCompleteField';
import {
  contratosInitialState,
  CONTRATOS_FILTER_COOD_COOP,
  CONTRATOS_FILTER_ID_ESCOLA,
  CONTRATOS_FILTER_ID_ESTADO,
  CONTRATOS_FILTER_NOM_CIDADE,
} from '../../pages/Contratos/Fluxos/Contratos';
import {
  loadEscolasPorCidade,
  loadEscolasPorCooperativaEstadoCidade,
} from '../../store/modules/EscolasActions';
import {
  loadAllEstadosByCoops,
  loadCidadesByEstadoId,
  loadEstados,
} from '../../store/modules/LogradouroActions';
import styles from './FiltrosListagemContratoEntePrivado.scss';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  filters: null,
  emptyEstados: null,
  emptyCidades: null,
  emptyEscolas: null,
};
class FiltrosListagemContratoEntePrivado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
      filters: this.props.filters,
      emptyEstados: {
        cpf: contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO],
        nome: this.props.languageValues.allEstados,
      },
      emptyCidades: {
        cpf: contratosInitialState.filters[CONTRATOS_FILTER_NOM_CIDADE],
        nome: this.props.languageValues.allCidades,
      },
      emptyEscolas: {
        id: contratosInitialState.filters[CONTRATOS_FILTER_ID_ESCOLA],
        nome: this.props.languageValues.todosEscolas,
      },
      estado: 0,
      cidade: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.loadEstados();
  }

  componentDidMount() {
    this.loadEscolas();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let needLoadEstados = false;
    let needLoadCidades = false;
    let needLoadEscolas = false;
    if (
      nextProps.filters[CONTRATOS_FILTER_COOD_COOP] !==
      this.state.filters[CONTRATOS_FILTER_COOD_COOP]
    ) {
      needLoadEstados = true;
    }
    if (
      nextProps.filters[CONTRATOS_FILTER_ID_ESTADO] !==
      this.state.filters[CONTRATOS_FILTER_ID_ESTADO]
    ) {
      needLoadCidades = true;
    }
    if (
      nextProps.filters[CONTRATOS_FILTER_COOD_COOP] !==
        this.state.filters[CONTRATOS_FILTER_COOD_COOP] ||
      nextProps.filters[CONTRATOS_FILTER_ID_ESTADO] !==
        this.state.filters[CONTRATOS_FILTER_ID_ESTADO] ||
      nextProps.filters[CONTRATOS_FILTER_NOM_CIDADE] !==
        this.state.filters[CONTRATOS_FILTER_NOM_CIDADE]
    ) {
      needLoadEscolas = true;
    }
    this.setState(
      {
        filters: { ...nextProps.filters },
      },
      () => {
        if (needLoadEstados) {
          this.loadEstados();
        }
        if (needLoadCidades) {
          this.loadCidades();
        }
        if (needLoadEscolas) {
          this.loadEscolas();
        }
      }
    );
  }

  hasCoopSelected = () => {
    return this.props.filters[CONTRATOS_FILTER_COOD_COOP] !==
      contratosInitialState.filters[CONTRATOS_FILTER_COOD_COOP]
      ? true
      : false;
  };

  getUFByIdEstado = (idEstado) => {
    const estados = this.props.logradouro.estados.filter(estado => estado.id === idEstado);
    return (estados && estados.length > 0) ? estados[0].sigla : '';
  };

  onLoadedEstados = () => {
    this.loadCidades();
  };

  loadEstados = () => {
    if (this.hasCoopSelected()) {
      this.props.loadAllEstadosByCoops(
        [this.props.filters[CONTRATOS_FILTER_COOD_COOP]],
        this.onLoadedEstados
      );
    } else {
      this.props.loadEstados(this.onLoadedEstados);
    }
  };

  loadCidades = () => {
    const idEstado = this.props.filters[CONTRATOS_FILTER_ID_ESTADO];
    let uf;
    if (
      idEstado !== contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO]
    ) {
      uf = this.getUFByIdEstado(idEstado).toLowerCase();
      this.props.loadCidadesByEstadoId(idEstado, uf);
    }
  };

  loadEscolas = () => {
    const codCoop = this.props.filters[CONTRATOS_FILTER_COOD_COOP];
    const idEstado = this.props.filters[CONTRATOS_FILTER_ID_ESTADO];
    const nomCidade = this.props.filters[CONTRATOS_FILTER_NOM_CIDADE];
    this.props.loadEscolasPorCooperativaEstadoCidade(
      codCoop,
      idEstado,
      nomCidade
    );
  };

  getEstados = () => {
    const estados = this.hasCoopSelected()
      ? this.props.logradouro.allEstadosByCoops
      : this.props.logradouro.estados;
    if (estados.length > 0) {
      return [{ ...this.state.emptyEstados }, ...estados];
    }
    return [];
  };

  estadosIsLoading = () => {
    return this.hasCoopSelected()
      ? this.props.logradouro.loadingAllEstadosByCoops
      : this.props.logradouro.loadingEstados;
  };

  estadosPlaceholder = () => {
    if (this.estadosIsLoading()) {
      return this.props.languageValues.loadingEstados;
    }
    return this.getEstados().length > 0
      ? this.props.languageValues.allEstados
      : this.props.languageValues.nenhumEstadoCarregado;
  };

  getCidades = () => {
    const uf = this.getUFByIdEstado(
      this.props.filters[CONTRATOS_FILTER_ID_ESTADO]
    ).toLowerCase();
    const cidades = this.props.logradouro.cidades[uf] || [];
    if (cidades.length > 0) {
      return [{ ...this.state.emptyCidades }, ...cidades];
    }
    return [];
  };

  cidadesIsLoading = () => {
    return this.props.logradouro.loadingCidades;
  };

  cidadesPlaceholder = () => {
    if (this.cidadesIsLoading()) {
      return this.props.languageValues.loadingCidades;
    }
    return this.getCidades().length > 0
      ? this.props.languageValues.allCidades
      : this.props.languageValues.nenhumaCidadeCarregada;
  };

  cidadesIsDisabled = () => {
    return (
      this.cidadesIsLoading() ||
      this.props.filters[CONTRATOS_FILTER_ID_ESTADO] ===
        contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO]
    );
  };

  getEscolas = () => {
    const escolas = this.props.escolas.escolasPorCooperativaEstadoCidade || [];
    if (escolas.length > 0) {
      return [{ ...this.state.emptyEscolas }, ...escolas];
    }
    return [];
  };

  escolasIsLoading = () => {
    return this.props.escolas.loadingEscolasPorCooperativaEstadoCidade;
  };

  escolasPlaceholder = () => {
    if (this.escolasIsLoading()) {
      return this.props.languageValues.loadingEscolas;
    }
    return this.getEscolas().length > 0
      ? this.props.languageValues.todosEscolas
      : this.props.languageValues.nenhumaEscolaCarregada;
  };

  escolasIsDisabled = () => {
    return this.escolasIsLoading();
  };

  render() {
    return (
      <>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.contratoEstados}
            className={rootClassName + '-estados-filter'}
            inputClassName={rootClassName + '-estados-input-filter'}
            placeholder={this.estadosPlaceholder()}
            options={this.getEstados().map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_ID_ESTADO]}
            onChange={(value) => {
              if (
                value &&
                value.value !== this.props.filters[CONTRATOS_FILTER_ID_ESTADO]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESTADO]: value.value,
                });
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESTADO]:
                    contratosInitialState.filters[CONTRATOS_FILTER_ID_ESTADO],
                });
              }
            }}
            disabled={this.props.loading || this.estadosIsLoading()}
            loading={this.estadosIsLoading()}
          />
        </Col>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.contratoCidades}
            className={rootClassName + '-cidades-filter'}
            inputClassName={rootClassName + '-cidades-input-filter'}
            placeholder={this.cidadesPlaceholder()}
            options={this.getCidades().map((cidade) => {
              if (cidade.nome === 'Todas as cidades') {
                return {
                  label: cidade.nome,
                  value: undefined,
                };
              }

              return {
                label: cidade.nome,
                value: cidade.nome,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_NOM_CIDADE]}
            onChange={(value) => {
              if (
                value &&
                value.value !== this.props.filters[CONTRATOS_FILTER_NOM_CIDADE]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_NOM_CIDADE]: value.value,
                });
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_NOM_CIDADE]:
                    contratosInitialState.filters[CONTRATOS_FILTER_NOM_CIDADE],
                });
              }
            }}
            disabled={this.props.loading || this.cidadesIsDisabled()}
            loading={this.cidadesIsLoading()}
            loadingMessage={this.props.languageValues.loadingCidades}
          />
        </Col>
        <Col cols={[12, 12, 6, 6, 6]}>
          <NewAutoCompleteField
            label={this.props.languageValues.escola}
            className={rootClassName + '-escolas-filter'}
            inputClassName={rootClassName + '-escolas-input-filter'}
            placeholder={this.escolasPlaceholder()}
            options={this.getEscolas().map((escola) => {
              return {
                label: escola.nome,
                value: escola.id,
              };
            })}
            value={this.props.filters[CONTRATOS_FILTER_ID_ESCOLA]}
            onChange={(value) => {
              if (
                value &&
                value.value !== this.props.filters[CONTRATOS_FILTER_ID_ESCOLA]
              ) {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESCOLA]: value.value,
                });
              } else {
                this.props.changeValues({
                  [CONTRATOS_FILTER_ID_ESCOLA]:
                    contratosInitialState.filters[CONTRATOS_FILTER_ID_ESCOLA],
                });
              }
            }}
            disabled={this.props.loading || this.escolasIsDisabled()}
            loading={this.escolasIsLoading()}
            loadingMessage={this.props.languageValues.carregandoEscolas}
          />
        </Col>
      </>
    );
  }
}

FiltrosListagemContratoEntePrivado.propTypes = {
  loading: PropTypes.bool,
  filters: PropTypes.object.isRequired,
  changeValues: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  logradouro: state.logradouro,
  contratos: state.contratos,
  escolas: state.escolas,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadEstados,
      loadCidadesByEstadoId,
      loadAllEstadosByCoops,
      loadEscolasPorCooperativaEstadoCidade,
      loadEscolasPorCidade,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FiltrosListagemContratoEntePrivado);
